import { townColorHex as hex, type TownPropPalette } from './townPropTemplates';

/** 430×364, bottom-centered: top beam touches the real roof underside. */
export function buildFenwatchBeaconBody(p: TownPropPalette): string {
  const posts = [36, 366].map((x, i) => `<g data-part="fenwatch-stilt">
    <path d="M${x} 16H${x + 28}V343H${x}Z" fill="${hex(p.wood)}"/>
    <path d="M${x + 4} 24H${x + 10}V337H${x + 4}Z" fill="${hex(p.woodEdge)}" opacity=".7"/>
    <path d="M${x + 19} 27L${x + 16} 79L${x + 20} 116L${x + 17} 170L${x + 20} 235L${x + 17} 318"
      fill="none" stroke="${hex(p.iron)}" stroke-width="2" opacity=".6"/>
    <path d="M${x - 3} 69H${x + 31}V82H${x - 3}Z M${x - 3} 246H${x + 31}V260H${x - 3}Z" fill="${hex(p.iron)}"/>
    <circle cx="${x + 14}" cy="76" r="2.3" fill="${hex(p.woodEdge)}"/>
    <circle cx="${x + 14}" cy="253" r="2.3" fill="${hex(p.woodEdge)}"/>
    <path d="M${x - 12} 332H${x + 43}L${x + 49} 344V364H${x - 17}V344Z" fill="${hex(p.stone)}"/>
    <path d="M${x - 10} 335H${x + 41}M${x - 14} 347H${x + 45}M${x + 14} 345V363"
      stroke="${hex(p.shade)}" stroke-width="2"/>
    <path d="M${x - 3} 325L${x + 7} 310L${x + 11} 326L${x + 23} ${i ? 307 : 314}L${x + 30} 333"
      fill="none" stroke="${hex(p.primary)}" stroke-width="3" opacity=".65"/>
  </g>`).join('');
  return `<g data-part="fenwatch-beacon-frame">
    <g data-part="fenwatch-bracing" fill="${hex(p.wood)}" stroke="${hex(p.woodEdge)}" stroke-width="1.2">
      <path d="M58 291L194 20H216L72 312Z"/>
      <path d="M372 291L236 20H214L358 312Z"/>
      <path d="M65 36L166 114L156 132L62 58Z M365 36L264 114L274 132L368 58Z"/>
    </g>
    ${posts}
    <g data-part="fenwatch-beacon-lamp">
      <path d="M150 34H280V203H150Z" fill="${hex(p.shade)}"/>
      <path d="M156 39H274V193H156Z" fill="${hex(p.wood)}"/>
      <path d="M174 52H256V176H174Z" fill="${hex(p.iron)}"/>
      <path d="M180 58H250V170H180Z" fill="${hex(p.glass)}" opacity=".7"/>
      <path d="M187 60H202V166H187Z" fill="${hex(p.glassCore)}" opacity=".36"/>
      <path d="M209 51H220V177H209Z M173 110H257V120H173Z" fill="${hex(p.wood)}"/>
      <path d="M214 135Q203 148 213 162Q225 153 214 135Z" fill="${hex(p.glassCore)}"/>
      <path d="M147 33H283V44H147Z M146 192H284V205H146Z" fill="${hex(p.woodEdge)}"/>
      <path d="M156 204L183 226H247L274 204Z" fill="${hex(p.wood)}"/>
      <path d="M166 206L187 220H243L264 206" fill="none" stroke="${hex(p.woodEdge)}" stroke-width="2"/>
      <path d="M165 55V180M265 55V180" stroke="${hex(p.woodEdge)}" stroke-width="2" opacity=".65"/>
    </g>
    <g data-part="fenwatch-flat-roof-contact">
      <path d="M0 0H430V19L416 25H15L0 18Z" fill="${hex(p.wood)}"/>
      <path d="M0 0H430V5H0Z" fill="${hex(p.woodEdge)}"/>
      <path d="M17 14L85 12L117 15H222L250 11L309 15H414" fill="none" stroke="${hex(p.woodEdge)}" stroke-width="1.7" opacity=".75"/>
      <path d="M36 0H47V25H36Z M384 0H395V25H384Z M209 0H221V25H209Z" fill="${hex(p.iron)}"/>
      <circle cx="41.5" cy="12" r="2" fill="${hex(p.stone)}"/><circle cx="389.5" cy="12" r="2" fill="${hex(p.stone)}"/>
    </g>
  </g>`;
}
